import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

import { BreadcrumbItem } from '@digital-platform/rs-cms/domain';
import { IconComponent } from '@digital-platform/rs-shared/ui-brand';

@Component({
  selector: 'digital-platform-breadcrumbs',
  standalone: true,
  imports: [CommonModule, RouterModule, IconComponent],
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent {
  @Input() public hideHome = false;
  @Input() public nestedBreadcrumbItem: BreadcrumbItem[] = [];

  public isRoutableLink(maybeRoute: string): boolean {
    const absoluteUrlPattern = new RegExp('^(?:[a-z+]+:)?//', 'i');

    if (absoluteUrlPattern.test(maybeRoute)) {
      return false;
    }

    return true;
  }
}
